export default __webpack_public_path__ + "static/rovo-menu-dont-dark-4a233989086cbe0fdd81e06927ec3700.png";